/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalsignin_Passkey_UnsupportedInputs */

const en_portalsignin_passkey_unsupported = /** @type {(inputs: Portalsignin_Passkey_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This browser cannot use a passkey. Use the email link instead.`)
};

/** @type {(inputs: Portalsignin_Passkey_UnsupportedInputs) => LocalizedString} */
const ar_portalsignin_passkey_unsupported = en_portalsignin_passkey_unsupported;

/** @type {(inputs: Portalsignin_Passkey_UnsupportedInputs) => LocalizedString} */
const he_portalsignin_passkey_unsupported = en_portalsignin_passkey_unsupported;

/** @type {(inputs: Portalsignin_Passkey_UnsupportedInputs) => LocalizedString} */
const ur_portalsignin_passkey_unsupported = en_portalsignin_passkey_unsupported;

/** @type {(inputs: Portalsignin_Passkey_UnsupportedInputs) => LocalizedString} */
const es_portalsignin_passkey_unsupported = en_portalsignin_passkey_unsupported;

/** @type {(inputs: Portalsignin_Passkey_UnsupportedInputs) => LocalizedString} */
const fr_portalsignin_passkey_unsupported = en_portalsignin_passkey_unsupported;

/** @type {(inputs: Portalsignin_Passkey_UnsupportedInputs) => LocalizedString} */
const de_portalsignin_passkey_unsupported = en_portalsignin_passkey_unsupported;

/** @type {(inputs: Portalsignin_Passkey_UnsupportedInputs) => LocalizedString} */
const pt_portalsignin_passkey_unsupported = en_portalsignin_passkey_unsupported;

/** @type {(inputs: Portalsignin_Passkey_UnsupportedInputs) => LocalizedString} */
const hi_portalsignin_passkey_unsupported = en_portalsignin_passkey_unsupported;

/** @type {(inputs: Portalsignin_Passkey_UnsupportedInputs) => LocalizedString} */
const bn_portalsignin_passkey_unsupported = en_portalsignin_passkey_unsupported;

/**
* | output |
* | --- |
* | "This browser cannot use a passkey. Use the email link instead." |
*
* @param {Portalsignin_Passkey_UnsupportedInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalsignin_passkey_unsupported = /** @type {((inputs?: Portalsignin_Passkey_UnsupportedInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalsignin_Passkey_UnsupportedInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalsignin_passkey_unsupported(inputs)
	if (locale === "he") return he_portalsignin_passkey_unsupported(inputs)
	if (locale === "ur") return ur_portalsignin_passkey_unsupported(inputs)
	if (locale === "es") return es_portalsignin_passkey_unsupported(inputs)
	if (locale === "fr") return fr_portalsignin_passkey_unsupported(inputs)
	if (locale === "de") return de_portalsignin_passkey_unsupported(inputs)
	if (locale === "pt") return pt_portalsignin_passkey_unsupported(inputs)
	if (locale === "hi") return hi_portalsignin_passkey_unsupported(inputs)
	if (locale === "bn") return bn_portalsignin_passkey_unsupported(inputs)
	return /** @type {LocalizedString} */ ("This browser cannot use a passkey. Use the email link instead.")
});